




































































































import Vue from 'vue'
import { parseMap, convertSeconds, isDisplayShow } from '@/utils/index'
import { planStatusMap, planStatusMapColor, planCategoryMap } from '@/utils/commonDef'
import dayjs from 'dayjs'
import { ProductionStatisticsServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import OrderProcess from './OrderProcess.vue'
const productionStatisticsServiceProxy = new ProductionStatisticsServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()
import AdvancedSearch from '@/components/AdvancedSearch'
import { exportProcess } from '../../../../../api/api'

export default Vue.extend({
  name: '',
  components: {
    OrderProcess,
    AdvancedSearch
  },
  data() {
    return {
      data: [],
      loading: false,
      pageSize: 18,
      currentPage: 1,
      searchDto: {
        typeId: '',
        filterPlus: false,
        planStatus: ['1', '2', '3', '4'],
        param: {}
      },
      planStatusMap,
      planStatusMapColor,
      planStatusList: parseMap(planStatusMap),
      selectedRowKeys: [],
      currentPlan: null,
      customRow: (record) => {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self: any = this
        return {
          on: {
            click: (e) => {
              self.currentPlan = { ...record }
              self.selectedRowKeys = [self.currentPlan.id]
            }
          }
        }
      },
      planCategoryMap,
      totalContent: 0, // 表格总数
      productColums: [], // 产品表格的字段
      showColumns: [],
      tableScrollWidth: 1700,
      isLoadComplete: false,
      tableScrollHeight: 200,
      workOrderScrollHeight: 200,
      resizeTimer: null,
      bodyTableBody: null,
      workOrderTableBody: null,
      selectArr: [],
      defaultSelect: {}
    }
  },
  created() {
    this.getSelectArr();
    this.getTableColumn()
    this.load()
  },
  updated() {
    this.tableScrollHeight = document.querySelector('.body').clientHeight - 78
    this.workOrderScrollHeight = document.querySelector('.footer').clientHeight - 68
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys }: any = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: [], selectedRows: []) => {
          this.selectedRowKeys = selectedRowKeys
          if (this.selectedRowKeys.length === 1) {
            this.currentPlan = this.data.find((res) => res.id === this.selectedRowKeys[0]) || {}
          }
        }
      }
    },
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
    exportFn() {
      const params = {
        bizCode: 'stat_process_plan',
        bizDataId: this.searchDto.typeId,
        current: this.currentPage,
        size: this.pageSize,
        tenantId: ''
      }
      return exportProcess.bind(this, this.searchDto, params)
    },
  },
  watch: {
    'searchDto.planStatus'() {
      this.load()
    }
  },
  methods: {
    getSelectArr() {
      let arr = JSON.parse(localStorage.getItem('coproduction'));
      let  arrX = [];

      for(var i=0; i<arr.length; i++) {
        let obj = {
          label: arr[i].name,
          value: arr[i].id
        }
        arrX.push(obj)
      }
      this.selectArr = arrX;

      this.defaultSelect = {
        key: arr[0].id,
        label: arr[0].name
      }
      this.searchDto.typeId = arr[0].id;

    },
    changeProduction(e) {
      console.log(e);
      this.searchDto.typeId = e.key.toString()
      this.getTableColumn()
      this.load()  
    },
    showStatusColor(value) {
      const status = this.searchDto.planStatus.find((res) => res == value)
      let color = ''
      if (status) {
        color = this.planStatusMapColor[value]
      }
      return color
    },
    inSearchStatus(value) {
      console.log(value)
      const status = this.searchDto.planStatus.find((res) => res == value)
      let boolean = false
      if (status) {
        boolean = true
      }
      return boolean
    },
    inputStatus(value) {
      const newTags = [...this.searchDto.planStatus]
      const status = this.searchDto.planStatus.find((res) => res == value)
      if (!status) {
        this.searchDto.planStatus.push(value)
      } else {
        this.searchDto.planStatus = newTags.filter((res) => res != value)
      }
    },
    ChangeColHeight(value) {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      this.resizeTimer = setTimeout(function() {
        this.tableScrollHeight = document.querySelector('.body').clientHeight
        this.workOrderScrollHeight = document.querySelector('.footer').clientHeight
        const bodyTableBody: any = document.querySelector('.body .ant-table-body')
        if (bodyTableBody) {
          bodyTableBody.style.maxHeight = this.tableScrollHeight - 68 + 'px'
        }
        const ProcessTableBody: any = document.querySelector('.footer .ant-table-body')
        if (ProcessTableBody) {
          ProcessTableBody.style.maxHeight = this.workOrderScrollHeight - 68 + 'px'
        }
      }, 100)
    },
    reload(data) {
      this.searchDto.filterPlus = true
      this.searchDto.param = data
      this.currentPage = 1
      this.$nextTick(() => this.load())
    },
    load() {
      this.selectedRowKeys = []
      this.loading = true
      productionStatisticsServiceProxy
        .getProductionProcessScheduleAnalysis(this.currentPage, this.searchDto, this.pageSize)
        .then((res) => {
          this.loading = false
          this.data = []
          this.isLoadComplete = true
          if (res.records.length > 0) {
            this.currentPlan = res.records[0]
            this.selectedRowKeys = [this.currentPlan.id]
            this.totalContent = res.total
            res.records.forEach((res: any) => {
              res.planEndTime = this.covertTime(res.planEndTime)
              res.planStartTime = this.covertTime(res.planStartTime)
              res.acquisitionTimedifference = convertSeconds(res.acquisitionTimedifference)
              res.collectionTotalTime = convertSeconds(res.collectionTotalTime)
              res.reportTimeDifference = convertSeconds(res.reportTimeDifference)
              res.reportTotalTime = convertSeconds(res.reportTotalTime)
              res.standardTotalTime = convertSeconds(res.standardTotalTime)
              res.totleWorkHours = convertSeconds(res.totleWorkHours)
            })
            this.data = res.records
          } else {
            this.totalContent = 0
            this.currentPlan = null
          }
        })
    },
    toggle($event) {
      // this.pageSize = $event ? 7 : 15
      // this.load()
    },
    //转换时间
    covertTime(time) {
      if (time) {
        return dayjs(time).format('YYYY-MM-DD') || ''
      }
      return ''
    },
    pageIndexchange(currentPage) {
      this.currentPage = currentPage
      this.load()
    },
    // 获取指定业务的字段列表
    async getTableColumn() {
      this.productColums = []
      this.productColums = await tenantBizFieldServiceProxy.getTenantBizField(
        'stat_process_plan',
        this.searchDto.typeId
      )
      this.handleColumns()
    },
    handleColumns() {
      this.showColumns = []
      if (!this.productColums || !this.productColums.length) {
        return
      }
      // 字段排序
      this.productColums.sort((a, b) => {
        return a.sort - b.sort
      })
      // 字段显隐
      let columns = []
      const timeArr = ['planStartTime', 'planEndTime']
      this.productColums.map((item) => {
        if (isDisplayShow(item.isDisplay, 2)) {
          // 自定义字段：产品类型
          const temp: any = {
            title: item.title,
            key: item.code,
            dataIndex: item.code,
            ellipsis: true
          }
          if (temp.key === 'code') {
            temp.width = 140
          } else if (timeArr.includes(temp.key)) {
            temp.width = 150
          } else {
            temp.width = (temp.title.length + 1) * 20
          }
          columns.push(temp)
        }
      })
      this.showColumns = [...columns]
      let num = this.productColums.filter((item) => isDisplayShow(item.isDisplay, 2)).length
      this.tableScrollWidth = num * 100
      console.log('showColumns:', this.showColumns)
    },
    totalFanyi(number: any) {
      const total = this.$t('Total…items')
      return total.replace('{0}', number)
    }
  }
})
